export default __webpack_public_path__ + "static/media/img4.2a5b1c08.png";